import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { FeriadoAreaComumDTO } from "app/models/feriadoAreaComumDTO";
import { Observable } from "rxjs";

export abstract class AbAreaComum extends AppService {
  abstract getAllAreaComum(): Observable<any>;
  abstract getAllAreaComumAgendavel(): Observable<any>;
  abstract getAllAreaComumDTOAgendavel(): Observable<any>;
  abstract getAllAreaComumDTOPorteiroAgendavel(): Observable<any>;
  abstract getAllAreaComumDTOPorteiroAgendavelFilter(filter: AppFilter): Observable<any>;
  abstract getAreaComumById(id: number): Observable<any>;
  abstract getAreaComumByFilter(filter: AppFilter): Observable<any>;
  abstract getAllAreasComuns(id: number): Observable<any>;
  abstract salvarAreaComum(areacomum);
  abstract deletarAreaComum(id);
  abstract getRegraAgendamentoByAreaComumId(id: number): Observable<any>;
  abstract getRegraAgendamentoByAreaComumIdV2(id: number): Observable<any>;
  abstract getTermosDeUso(regraAgendamentoId: number): Observable<string>;
  abstract salvarRegraAgendamento(regraagendamento);
  abstract getAllFeriadosByFilter(filter: AppFilter): Observable<any>;
  abstract saveFeriadoAreaComum(feriadoAreaComum: Array<FeriadoAreaComumDTO>);
  abstract findFeriadoByAreaComumId(id: number): Observable<any>;
  abstract findPeriodoByRegraAgendamentoId(filter: AppFilter): Observable<any>;
  abstract getHabilitarControleAcessoVinculado(id: number, controleAcessoVinculado: boolean): Observable<any>;
}
